// src/api/client.js
import axios from 'axios';
import Cookies from 'js-cookie';
import config from '../config/env';
import { SESSION_NAME } from '../contexts/session-context';

const API_KEY = 'darwintec-solutions-X-bpp';

export function createHttpClient() {
  const http = axios.create({
    baseURL: config.api,
    withCredentials: false,
  });

  http.interceptors.request.use((conf) => {
    // ลองหา token จาก Cookie ก่อน
    let token = Cookies.get(SESSION_NAME) || '';
    
    // ถ้าไม่มีใน Cookie ให้ลองหาใน localStorage (สำหรับ LINE login)
    if (!token) {
      token = localStorage.getItem("token") || '';
    }
    
    conf.headers['X-API-KEY'] = API_KEY;
    conf.headers.Authorization = token ? `Bearer ${token}` : '';
    return conf;
  });

  http.interceptors.response.use(
    (res) => res,
    (err) => Promise.reject(err)
  );

  return http;
}

export default function useApiClient() {
  const http = createHttpClient();
  const post = (route, data, extra = {}) => http.post(`/${route}`, data, extra);
  const get  = (route, params = {}, responseType, extra = {}) =>
    http.get(`/${route}`, { params, ...(responseType ? { responseType } : {}), ...extra });
  const getById = (route, id, extra = {}) => http.get(`/${route}/${id}`, extra);
  const del = (route, id, extra = {}) => http.delete(id != null ? `/${route}/${id}` : `/${route}`, extra);
  const patch = (route, id, data, extra = {}) => http.patch(`/${route}/${id}`, data, extra);
  const put = (route, data, extra = {}) => http.put(`/${route}`, data, extra);
  return { post, get, getById, del, patch, put, http };
}
